import { __assign } from "tslib";
import * as React from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import { useField } from 'formik';
import { BLayout } from '../BLayout';
var useStyles = makeStyles({
    chip: {
        padding: 2
    }
});
/**
 * **Must be a child of BForm**
 *
 * This component provides a Material-UI chip that can be used as a button. It is visually identical to BChipGroup's individual chips.
 *
 * That is, if you'd just like a single chip to exist, usually as a button, you should use this component instead of BChipGroup
 *
 *  **Required Props:**
 *  - name
 *   - must match the name from initialValues
 *
 * **Optional Props:**
 * - label
 *  - The content of the label (inside the button). If not specified, value will default to the name.
 * - color
 *  - The color of the component
 * - onClick
 *  - Callback function fired when the button is clicked.
 * - onDelete
 *  - Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
 * - [chipProps](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/types/BChipProps.md)
 *  - Almost all Material UI Chip props
 * - [BLayoutProps](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/types/BLayoutProps.md)
 *  - custom gridding, sizes, and alignment
 *
 * **Basic Example:**
 * ```jsx
 * <BChipButton
 *    name="chip"
 *    label="Im a Chip"
 *    onDelete={() => { console.log('chip deleted') }}
 * />
 * ```
 *
 * Demos:
 *
 * - [Sample Form](http://mui-bueno.pipeline.east1.simoncomputing.com.s3-website-us-east-1.amazonaws.com/BChipButton)
 *
 * API:
 *
 * - [BChipButton API](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/tag-references/button/BChipButton.md)
 */
export var BChipButton = function (props) {
    var name = props.name, onDelete = props.onDelete, onClick = props.onClick, chipProps = props.chipProps, _a = props.label, label = _a === void 0 ? name : _a, _b = props.color, color = _b === void 0 ? 'default' : _b, _c = props.w, w = _c === void 0 ? 1 : _c, _d = props.ignoreGrid, ignoreGrid = _d === void 0 ? true : _d, className = props.className;
    var classes = useStyles();
    // Formik boilerplate ------------------
    var _e = useField(name), field = _e[0], helpers = _e[2];
    var setValue = helpers.setValue;
    var value = field.value;
    // -------------------------------------
    var onDeleteWrapped = function () {
        if (onDelete)
            onDelete();
        setValue(false);
    };
    if (!value) {
        return (React.createElement(React.Fragment, null));
    }
    return (React.createElement(BLayout, __assign({}, props, { w: w, ignoreGrid: ignoreGrid }),
        React.createElement("div", { className: classes.chip },
            React.createElement(Chip, __assign({ id: name + "-chip", size: 'medium', variant: 'default' }, chipProps, field, { color: color, label: label, onClick: onClick, onDelete: onDelete ? onDeleteWrapped : undefined, className: className })))));
};
//# sourceMappingURL=BChipButton.js.map